import { BarChart3, MessageSquare, Lightbulb } from 'lucide-react';

/** Right-side marketing panel used on all auth screens */
export function MarketingPanel() {
  return (
    <div className="hidden lg:flex flex-col justify-between h-full bg-gradient-to-br from-[#2d7a91] via-[#245f73] to-[#0f2b36] text-white p-12 lg:p-16 relative overflow-hidden">
      {/* Decorative gradient orbs for depth */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-gradient-to-bl from-[#3a9ab5]/20 to-transparent rounded-full -translate-y-1/3 translate-x-1/4" />
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-gradient-to-tr from-[#0a1f28]/40 to-transparent rounded-full translate-y-1/3 -translate-x-1/4" />
      <div className="absolute top-1/2 left-1/2 w-[300px] h-[300px] bg-gradient-to-r from-[#2d7a91]/10 to-transparent rounded-full -translate-x-1/2 -translate-y-1/2" />

      {/* Top — headline, aligned vertically with the logo on the left */}
      <div className="relative z-10 pt-24">
        <h2 className="text-4xl font-bold leading-tight mb-4">
          Turn customer feedback<br />into product wins
        </h2>
        <p className="text-white/70 text-lg max-w-md">
          Centralise, prioritise and act on the feedback that matters most to your customers and your business.
        </p>
      </div>

      {/* Middle — feature highlights */}
      <div className="relative z-10 space-y-8 my-12">
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-white/[0.08] border border-white/[0.1] flex items-center justify-center">
            <MessageSquare className="h-5 w-5 text-white/80" />
          </div>
          <div>
            <h3 className="font-semibold mb-1">Ensure everything stays on your radar</h3>
            <p className="text-sm text-white/60">Collect feedback from support, sales, social and NPS — all in one place.</p>
          </div>
        </div>
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-white/[0.08] border border-white/[0.1] flex items-center justify-center">
            <Lightbulb className="h-5 w-5 text-white/80" />
          </div>
          <div>
            <h3 className="font-semibold mb-1">Prioritise with confidence</h3>
            <p className="text-sm text-white/60">Link feedback to product ideas and see what your customers really want.</p>
          </div>
        </div>
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-white/[0.08] border border-white/[0.1] flex items-center justify-center">
            <BarChart3 className="h-5 w-5 text-white/80" />
          </div>
          <div>
            <h3 className="font-semibold mb-1">Measure impact</h3>
            <p className="text-sm text-white/60">Track trends and report on customer sentiment over time.</p>
          </div>
        </div>
      </div>

      {/* Bottom — footer */}
      <div className="relative z-10 pt-8 border-t border-white/[0.1] space-y-2">
        <p className="text-white/50 text-sm">
          Trusted by product teams worldwide
        </p>
        <p className="text-white/40 text-xs">
          <a
            href="https://productradar.co/docs/terms"
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:text-white/60 transition-colors"
          >
            Terms
          </a>
          {' · '}
          <a
            href="https://productradar.co/docs/privacy"
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:text-white/60 transition-colors"
          >
            Privacy
          </a>
        </p>
      </div>
    </div>
  );
}
